import i18n from '../i18n';

const configs = {
  appTypes: [
    {
      value: 'YMK',
      label: i18n.t('business:contactus.app.types.ymk', 'YouCam Makeup'),
    },
    {
      value: 'Y4B',
      label: i18n.t('business:contactus.app.types.y4b', 'YouCam for Business'),
    },
    {
      value: 'YCP',
      label: i18n.t('business:contactus.app.types.ycp', 'YouCam Perfect'),
    },
    {
      value: 'YCV',
      label: i18n.t('business:contactus.app.types.ycv', 'YouCam Video'),
    },
    {
      value: 'YCC',
      label: i18n.t('business:contactus.app.types.ycc', 'YouCam Cut'),
    },
    {
      value: 'YCN',
      label: i18n.t('business:contactus.app.types.ycn', 'YouCam Nail'),
    },
    {
      value: 'YCF',
      label: i18n.t('business:contactus.app.types.ycf', 'YouCam Fun'),
    },
  ],
  productTypes: [
    {
      value: 'P01_VIRTUAL_MAKEUP',
      label: i18n.t(
        'business:u.c.solutionlinks.virtual.makeup',
        'AR Virtual Makeup Try-On'
      ),
      keyword: 'virtual-makeup',
    },
    {
      value: 'P02_AI_SMART_SHADE_FINDER',
      label: i18n.t(
        'business:u.c.solutionlinks.ai.shade.finder',
        'AI Smart Shade Finder'
      ),
      keyword: 'shade-finder',
    },
    {
      value: 'P03_AI_FACIAL_RECOGNITION',
      label: i18n.t(
        'business:u.c.solutionlinks.ai.facial.recognition',
        'AI Facial Recognition'
      ),
      keyword: 'facial-recognition',
    },
    {
      value: 'P04_AR_SKIN_DIAGNOSTIC',
      label: i18n.t(
        'business:u.c.solutionlinks.ai.skin.diagnostic',
        'AI Skin Diagnostic'
      ),
      keyword: 'skin-diagnostic',
    },
    {
      value: 'P05_IN_STORE_BARCODE_TRY_ON',
      label: i18n.t(
        'business:contactus.product.types.in.store.barcode.try.on',
        'In-store Barcode Try On'
      ),
      keyword: 'barcode',
    },
    {
      value: 'P06_BEAUTY_ADVISOR_1_ON_1',
      label: i18n.t(
        'business:u.c.solutionlinks.ba.1.on.1',
        'Beauty Advisor 1-on-1'
      ),
      keyword: '1-on-1',
    },
    {
      value: 'P07_LIVE_AR_FOR_CORPORATE_TRAINING',
      label: i18n.t(
        'business:u.c.solutionlinks.live.ar.training',
        'Live AR for Corporate Training'
      ),
      keyword: 'training',
    },
    {
      value: 'P08_LIVE_STREAMING_FOR_BRANDS',
      label: i18n.t(
        'business:u.c.solutionlinks.live.streaming',
        'AR Live Casting for Web and Mobile App'
      ),
      keyword: 'streaming',
    },
    {
      value: 'P09_LIVE_HAIR_COLOR',
      label: i18n.t(
        'business:u.c.solutionlinks.live.hair.color',
        'Live Hair Color'
      ),
      keyword: 'hair-color',
    },
    {
      value: 'P10_VIRTUAL_ACCESSORIES',
      label: i18n.t(
        'business:u.c.solutionlinks.virtual.accessories',
        '3D Virtual Accessories AR Try-On '
      ),
      keyword: 'virtual-accessories',
    },
    {
      value: 'P11_PRODUCT_RECOMMENDATION',
      label: i18n.t(
        'business:contactus.product.types.product.recommendation',
        'Product Recommendation'
      ),
      keyword: 'recommendation',
    },
    {
      value: 'P12_COLOR_REPORT',
      label: i18n.t(
        'business:contactus.product.types.color.report',
        'Color Report'
      ),
      keyword: 'color-report',
    },
  ],
  employeeNumbers: [
    {
      value: 'C050',
      label: i18n.t('business:contactus.employee.num.50', '1 - 50 employees'),
    },
    {
      value: 'C100',
      label: i18n.t(
        'business:contactus.employee.num.100',
        '51 - 100 employees'
      ),
    },
    {
      value: 'C200',
      label: i18n.t(
        'business:contactus.employee.num.200',
        '101 - 200 employees'
      ),
    },
    {
      value: 'C300',
      label: i18n.t(
        'business:contactus.employee.num.300',
        '201 - 300 employees'
      ),
    },
    {
      value: 'C301500',
      label: i18n.t(
        'business:contactus.employee.num.301',
        '301 - 500 employees'
      ),
    },
  ],
  employeeNumbers4ContactUs: [
    {
      value: 'C050',
      label: i18n.t('business:contactus.employee.num.50', '1 - 50 employees'),
    },
    {
      value: 'C100',
      label: i18n.t(
        'business:contactus.employee.num.100',
        '51 - 100 employees'
      ),
    },
    {
      value: 'C200',
      label: i18n.t(
        'business:contactus.employee.num.200',
        '101 - 200 employees'
      ),
    },
    {
      value: 'C300',
      label: i18n.t(
        'business:contactus.employee.num.300',
        '201 - 300 employees'
      ),
    },
    {
      value: 'C301500',
      label: i18n.t(
        'business:contactus.employee.num.301',
        '301 - 500 employees'
      ),
    },
    {
      value: 'C999',
      label: i18n.t('business:contactus.employee.num.999', '500+ employees'),
    },
  ],
  businessTypes: [
    {
      value: 'MAKEUP',
      label: i18n.t('business:contactus.business.type.makeup', 'Makeup'),
    },
    {
      value: 'SKINCARE',
      label: i18n.t('business:contactus.business.type.skincare', 'Skincare'),
    },
    {
      value: 'MEDSPACLINIC',
      label: i18n.t(
        'business:contactus.business.type.medspa.clinic',
        'Medspa/Clinic'
      ),
    },
    {
      value: 'JEWELRYWATCHES',
      label: i18n.t(
        'business:contactus.business.type.jewelry.watches',
        'Jewelry/Watches'
      ),
    },
    {
      value: 'EYEWEAR',
      label: i18n.t(
        'business:contactus.business.type.eyewearbanner',
        'Eyewear'
      ),
    },
    {
      value: 'HAIRRELATED',
      label: i18n.t(
        'business:contactus.business.type.hair.related',
        'Hair Related'
      ),
    },
    {
      value: 'NAILS',
      label: i18n.t('business:contactus.business.type.nails', 'Nails'),
    },
    {
      value: 'COLORLENS',
      label: i18n.t(
        'business:contactus.business.type.color.lenses',
        'Color Lenses'
      ),
    },
    {
      value: 'AGENCY',
      label: i18n.t('business:contactus.business.type.agency', 'Agency'),
    },
    {
      value: 'MEDIA',
      label: i18n.t('business:contactus.business.type.media', 'Media'),
    },
    {
      value: 'OTHERS',
      label: i18n.t('business:contactus.business.type.others', 'Others'),
    },
  ],
  freeTrialBusinessTypes: [
    {
      value: 'BRAND',
      label: i18n.t('business:contactus.business.type.brand', 'Brand'),
    },
    {
      value: 'RETAILER',
      label: i18n.t('business:contactus.business.type.retailer', 'Retailer'),
    },
    {
      value: 'MANUFACTURER',
      label: i18n.t(
        'business:contactus.business.type.manufacturer',
        'Manufacturer'
      ),
    },
    {
      value: 'DIGITALAGENCY',
      label: i18n.t(
        'business:contactus.business.type.digital.agency',
        'Digital Agency'
      ),
    },
    {
      value: 'SYSTEMINTEGRATOR',
      label: i18n.t(
        'business:contactus.business.type.system.integrator',
        'System Integrator'
      ),
    },
    {
      value: 'OTHERS',
      label: i18n.t('business:contactus.business.type.others', 'Others'),
    },
  ],
  skincareBusinessTypes: [
    {
      value: 'BRAND',
      label: i18n.t('business:contactus.business.type.brand', 'Brand'),
    },
    {
      value: 'WELLNESSCENTER',
      label: i18n.t(
        'business:contactus.business.type.wellness.Clinic',
        'Wellness Clinic'
      ),
    },
    {
      value: 'MEDICALSPA',
      label: i18n.t(
        'business:contactus.business.type.medical.Clinic',
        'Med-Spa/Medical Aesthetic Clinic'
      ),
    },
    {
      value: 'FACIALBAR',
      label: i18n.t(
        'business:contactus.business.type.facial.bar',
        'Facial Bar'
      ),
    },
    {
      value: 'DAYSPA',
      label: i18n.t('business:contactus.business.type.day.spa', 'Day spa'),
    },
    {
      value: 'DERMATOLOGYPRATICE',
      label: i18n.t(
        'business:contactus.business.type.dermatology.pratice',
        'Dermatology practice'
      ),
    },
    {
      value: 'PLASTICSURGERYPRATICE',
      label: i18n.t(
        'business:contactus.business.type.plastic.surgery.practice',
        'Plastic Surgery practice'
      ),
    },
    {
      value: 'PHYSICIANPRACTICE',
      label: i18n.t(
        'business:contactus.business.type.other.specialty',
        'Other specialty/physician practice'
      ),
    },
  ],
  hearFrom: [
    {
      value: 'EMAIL_NEWSLETTER',
      label: i18n.t(
        'business:contactus.hear.from.email.newsletter',
        'Email / Newsletter'
      ),
    },
    {
      value: 'WEB_SEARCH',
      label: i18n.t(
        'business:contactus.hear.from.web.search',
        'Web Search (Google, etc.)'
      ),
    },
    {
      value: 'SOCIAL_MEDIA',
      label: i18n.t(
        'business:contactus.hear.from.social.media',
        'Social Media (LinkedIn, etc.)'
      ),
    },
    {
      value: 'WEBINAR_EVENTS',
      label: i18n.t(
        'business:contactus.hear.from.webinar.events',
        'Webinar / Events'
      ),
    },
    {
      value: 'ADVERTISEMENT',
      label: i18n.t(
        'business:contactus.hear.from.advertisement',
        'Advertisement'
      ),
    },
    {
      value: 'FRIEND_PARTNER',
      label: i18n.t(
        'business:contactus.hear.friend.partner',
        'Friend / Business Partner'
      ),
    },
    {
      value: 'OTHER',
      label: i18n.t('business:contactus.hear.from.other', 'Other'),
    },
  ],
  convertEmployee: value => {
    switch (value) {
      case 'C050':
        return 'R_1_50';
      case 'C100':
        return 'R_51_100';
      case 'C200':
        return 'R_101_200';
      case 'C300':
        return 'R_201_300';
      case 'C301500':
        return 'R_301_500';
      case 'C999':
        return 'R_501_999';
      default:
        return 'R_1_50';
    }
  },
  employeeMore200: value => {
    switch (value) {
      case 'C050':
        return false;
      case 'C100':
        return false;
      case 'C200':
        return false;
      case 'C300':
        return true;
      case 'C301500':
        return true;
      case 'C999':
        return true;
      default:
        return true;
    }
  },
  getQuestionTypes: () => [
    {
      label: i18n.t('business:contactus.question.type.account', 'Account'),
      options: [
        {
          value: 'Q01_ACCOUNT_MANAGEMENT',
          label: i18n.t(
            'business:contactus.question.type.account.management',
            'Management'
          ),
        },
        {
          value: 'Q02_ACCOUNT_BILLING_INFORMATION',
          label: i18n.t(
            'business:contactus.question.type.account.billing.info',
            'Billing Information'
          ),
        },
      ],
    },
    {
      label: i18n.t('business:contactus.question.type.purchase', 'Purchase'),
      options: [
        {
          value: 'Q03_PURCHASE_PAYMENT',
          label: i18n.t(
            'business:contactus.question.type.purchase.payment',
            'Payment'
          ),
        },
        {
          value: 'Q04_PURCHASE_PRODUCT_INFORMATION',
          label: i18n.t(
            'business:contactus.question.type.purchase.product.info',
            'Product Information'
          ),
        },
      ],
    },
    {
      label: i18n.t('business:contactus.question.type.feature', 'Feature'),
      options: [
        {
          value: 'Q05_FEATURE_HOWTO',
          label: i18n.t(
            'business:contactus.question.type.feature.howto',
            'How do I/How to'
          ),
        },
        {
          value: 'Q06_FEATURES_ISSUES',
          label: i18n.t(
            'business:contactus.question.type.feature.issues',
            'Issues/Errors/Trouble'
          ),
        },
      ],
    },
    {
      label: i18n.t('business:contactus.question.type.others', 'Others'),
      options: [
        {
          value: 'Q07_OTHERS',
          label: i18n.t('business:contactus.question.type.others', 'Others'),
        },
      ],
    },
  ],
};

export default configs;
